import { gql } from "@apollo/client";

const GET_ADDRESS = gql`
  query GetAddressList($input: GetListInput) {
    getAddress(input: $input) {
      data {
        addressList {
          address
          userId
          city
          country
          countryCode
          isDefault
          label
          postalCode
          _id
        }
        count
      }
      status
      error
    }
  }
`;

export default GET_ADDRESS;
